import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { PEDAGOGY } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/pedagogy/")({
  component: () => <DeptContentList cfg={PEDAGOGY} />,
});
